import React from 'react'
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'
import icon from '../../../images/icon/magic02.svg'
import about3 from '../../../images/about-orbitronix.webp'
import abicon1 from '../../../images/icon/frature-icon01.png'
import abicon2 from '../../../images/icon/frature-icon02.png'
import abicon3 from '../../../images/icon/frature-icon03.png'
import abicon4 from '../../../images/icon/frature-icon04.png'

const About = (props) => {
    const { t, i18n } = useTranslation();

    return (
        <section className="about pt-0 pb-120" style={{ marginTop: -15 }}>
            <div className="container">
                <div className="cs-about-wrap pos-rel">
                    <div className="row mt-none-60">
                        <div className="col-lg-6 pt-60">
                            <div className="cs-about_left">
                                <div className="sec-title--two sec-title--three pt-60">
                                    <motion.div
                                        initial={{ opacity: 0, y: 30 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 1 }}
                                    >
                                        <div>
                                            <span className="sub-title wow fadeInUp" data-wow-duration="600ms">
                                                <img src={icon} alt="Sparkle Icon" title="OrbitroniX" />
                                                <span>{t('about.shortTitle')}</span>
                                            </span>
                                        </div>
                                    </motion.div>
                                    <motion.div
                                        initial={{ opacity: 0, y: 30 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 1.2, delay: 0.2 }}
                                    >
                                        <div className='pt-20'>
                                            <h2 className="title wow skewIn" data-wow-delay="150ms" data-wow-duration="600ms">
                                                {t('about.mainTitle')}
                                            </h2>
                                        </div>
                                    </motion.div>
                                    <motion.div
                                        initial={{ opacity: 0, y: 30 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 1.4, delay: 0.4 }}
                                    >
                                        <div>
                                            <p className="content wow fadeInUp" data-wow-delay="300ms" data-wow-duration="600ms">
                                                {t('about.description')}
                                            </p>
                                        </div>
                                    </motion.div>
                                </div>
                                <motion.div
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1.4, delay: 0.6 }}
                                    className="xb-btn mt-55 wow fadeInUp" data-wow-delay="450ms" data-wow-duration="600ms"
                                >
                                    <Link 
                                        to={`/${i18n.language}/about`} 
                                        className="ExploreMore" 
                                        aria-label="Learn More About Orbitronix - Software Development Company"
                                        title={t('about.learnMore')}
                                    >
                                        {t('about.learnMore')}
                                    </Link>
                                </motion.div>
                            </div>
                        </div>
                    </div>
                    <div className="xb-shape">
                        <img 
                            src={about3} 
                            alt="About Orbitronix - Software Development" 
                            title="About OrbitroniX"
                            loading="lazy" 
                        />
                    </div>
                </div>
                <div className="cs-feature pos-rel pt-100 z-1">
                    <div className="row mt-none-30">
                        <div className="col-lg-3 col-md-6 cs-feature-col mt-30">
                            <div className="cs-feature-item">
                                    <div className="xb-item--icons">
                                        <img 
                                            src={abicon1} 
                                            alt={t('about.features.communication.title')} 
                                            title={t('about.features.communication.title')}
                                            loading="lazy" 
                                        />
                                    </div>
                                    <h3 className="xb-item--title">{t('about.features.communication.title')}</h3>
                                    <span className="xb-item--content">{t('about.features.communication.description')}</span>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 cs-feature-col mt-30">
                                <div className="cs-feature-item">
                                    <div className="xb-item--icons">
                                        <img 
                                            src={abicon2} 
                                            alt={t('about.features.details.title')} 
                                            title={t('about.features.details.title')}
                                            loading="lazy" 
                                        />
                                    </div>
                                    <h3 className="xb-item--title">{t('about.features.details.title')}</h3>
                                    <span className="xb-item--content">{t('about.features.details.description')}</span>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 cs-feature-col mt-30">
                                <div className="cs-feature-item">
                                    <div className="xb-item--icons">
                                        <img 
                                            src={abicon3} 
                                            alt={t('about.features.development.title')} 
                                            title={t('about.features.development.title')}
                                            loading="lazy" 
                                        />
                                    </div>
                                    <h3 className="xb-item--title">{t('about.features.development.title')}</h3>
                                    <span className="xb-item--content">{t('about.features.development.description')}</span>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 cs-feature-col mt-30">
                                <div className="cs-feature-item">
                                    <div className="xb-item--icons">
                                        <img 
                                            src={abicon4} 
                                            alt={t('about.features.launch.title')} 
                                            title={t('about.features.launch.title')}
                                            loading="lazy" 
                                        />
                                    </div>
                                    <h3 className="xb-item--title">{t('about.features.launch.title')}</h3>
                                    <span className="xb-item--content">{t('about.features.launch.description')}</span>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;